import { observer } from 'mobx-react-lite'
import Typography from '@mui/material/Typography'
import NavigateNextIcon from '@mui/icons-material/NavigateNext'
import Breadcrumbs, { BreadcrumbsProps } from '@mui/material/Breadcrumbs'
import useStore from 'reusable/mobx-store-utils'
import Link from '@mui/material/Link'
import { useOrgGuardStore } from 'features/main/main-router/org-guard/OrgGuardStore'
import { useRouterStore } from 'features/main/main-router/org-guard/RouterStore'
import { OrgDto } from '@gap/backend/app-services/org/models/OrgDto'

export default observer(function DocViewBreadcrumb({ clientOrg, docName, sx }: { clientOrg: Pick<OrgDto.entity, 'id' | 'name'>, docName: string, sx?: BreadcrumbsProps['sx'] }) {
   const orgGuardStore = useOrgGuardStore()
   const routerStore = useRouterStore()

   const docViewBreadcrumbStore = useStore((sp) => ({
      goToClientDocuments: (e?: React.MouseEvent) => {
         // Prevent default only if it's a regular click (not ctrl/cmd click)
         if (e && !e.ctrlKey && !e.metaKey) {
            e.preventDefault()
         }

         switch (orgGuardStore.userOrg.orgType) {
            case 'advisor': {
               sp.routerStore.goToNavPath(`clients/${clientOrg.id}/documents`, { orgId: sp.orgGuardStore.orgId })
               break
            }
            case 'client':
            default:
               sp.routerStore.goToNavPath(`documents`, { orgId: sp.orgGuardStore.orgId })
         }
      },
      get documentsHref() {
         switch (orgGuardStore.userOrg.orgType) {
            case 'advisor': {
               return `${orgGuardStore.orgId}/clients/${clientOrg.id}/documents`
            }
            case 'client':
            default:
               return `${orgGuardStore.orgId}/documents`
         }
      },
      get shouldShowClientInBreadcrumb() {
         return orgGuardStore.userOrg.orgType === 'advisor'
      }
   }), { orgGuardStore, routerStore })

   if (orgGuardStore.sp.authStore.isGuest) {
      return null
   }

   return <Breadcrumbs maxItems={3} separator={<NavigateNextIcon fontSize="small" />} sx={{ mt: 2, ...sx }}>
      {docViewBreadcrumbStore.shouldShowClientInBreadcrumb && <Typography>{clientOrg.name}</Typography>}
      <Link
         variant="body1"
         href={docViewBreadcrumbStore.documentsHref}
         onClick={docViewBreadcrumbStore.goToClientDocuments}
         sx={{ cursor: 'pointer' }}
      >
         Documents
      </Link>
      <Typography>{docName}</Typography>
   </Breadcrumbs>
})
